<template>
  <div v-orientation="orientation" v-resize="resize">
    <transition name="page">
      <div id="wet-app-preloader" class="preloader" v-if="!loadedPage"></div>
    </transition>
    <router-view class="wet-layout"/>
    <transition name="page">
      <loadingComponent v-if="$store.state.loading.length > 0" :Id="`wet-loading-${$route.name}`"/>
    </transition>
    <wetModal
      v-if="isDevelopment"
      id="wet-dev-api-errors-modal"
      icon="error"
      :opened="devMessage.length > 0"
      @close="() => $store.commit('DEL_DEV_MESSAGE', [])"
      :content="devMessage.map((m) => `<p>${m}</p>`).join('')"
      :actions="[
        {
          title: 'CLEAR API ERRORS',
          name: 'clear-dev-api-errors',
          event: () => $store.commit('DEL_DEV_MESSAGE', [])
        }
      ]"
    ></wetModal>
  </div>
</template>
<script>
import '@/assets/slick/slick.css';
import '@/assets/slick/slick-theme.css';
import '@/assets/css/style.scss';
import loadingComponent from '@/components/loadingComponent.vue';
import { mapState, mapGetters } from 'vuex';
import seo from '@/mixins/seo';
import LogService from '@/services/LogService';
import configEnv from '@/enums/configEnv';
import { eventNames } from '@/enums/googleTagManager';
import setLayout from '@/mixins/setLayout';
import common from '@/mixins/common';
import partnerCode from '@/mixins/partner-code';
import EnvService from '@/services/EnvService';
import getLang from "@/mixins/getLang";

export default {
  mixins: [seo, setLayout, common, partnerCode, getLang],
  components: {
    loadingComponent,
  },
  data() {
    return {
      loadedPage: false,
    };
  },
  beforeCreate() {
    // set moment locale
    this.$moment.locale(this.$store.state.lang);
    document.documentElement.lang = this.$store.state.lang;
  },
  created() {
    this.setCssVariables();
    // LogService.log('route', this.$route.name);
    // if (!configEnv.own_design_trigger.includes(this.$route.name)) {
    LogService.log('getDesign');
    this.getDesign();
    // }
    this.$store.dispatch('checkBrowser');
    this.pushDataLayer();
  },
  mounted() {
    this.$login();
    this.loadedPage = true;
    this.resize();
    window.addEventListener('scroll', this.scroll);

    // update view height
    this.setViewH();

    // update breakpoint
    this.$store.dispatch('getBreakpoint');

    //
    document.documentElement.style.setProperty('--bottombar-height', '0px');
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll);
  },
  computed: {
    ...mapState(['devMessage', 'strings']),
    ...mapGetters(['colorsRgb']),
    development() {
      return configEnv.nodeEnv === 'development';
    },
    metaFromStore() {
      return this.$store.state.meta || []; // Fallback, falls keine Meta-Daten vorhanden sind
    },
    dataLayerItem() {
      return {
        event: eventNames.pageView,
        pagePath: this.$route.path,
        pageTitle: this.meta.title,
        originalLocation: `${document.location.protocol}//\
${document.location.hostname}\
${this.$route.fullPath}`,
      };
    },
  },
  watch: {
    'strings.frontPageMenu': {
      handler(newValue) {
        console.log('frontPageMenu updated:', newValue);
        if (newValue !== undefined) {
          this.getWpFrontMenu();
        }
      },
      deep: false,       // Detects changes inside nested properties
      immediate: false   // Optional: triggers immediately with the initial value on component load
    },
    $route() {
      /* call the route dependent methods: */
      const lang = this.getLang();
      this.setMeta(lang);
      document.documentElement.lang = lang;
      LogService.log('meta info', this.meta);
      this.$moment.locale(lang);
      this.pushDataLayer();
    },
  },
  methods: {
    isDevelopment() {
      return EnvService.localOrDev();
    },
    resize() {
      // set globale event when event window.resize
      this.$root.$emit('resize', true);

      // update view height
      this.setViewH();

      // update breakpoint
      this.$store.dispatch('getBreakpoint');

      // update $isMobile
      this.calcIsMobile();
    },
    scroll() {
      // set globale event when event window.scroll
      this.$root.$emit('scroll', true);
    },
    orientation() {
      this.setViewH();

      // update $isMobile
      this.calcIsMobile();
    },
    setViewH() {
      document.documentElement.style.setProperty('--view-height', `${window.innerHeight}px`);
    },
    getWpFrontMenu() {
      // get front page menu
      let { lang } = this.$route.params;
      if (lang === configEnv.default_wp_language) {
        lang = '';
        LogService.log('default language, setting lang to ""');
      }
      LogService.log('menu', this.strings.frontPageMenu.items);
      this.$store.commit('SET_MENU', this.strings.frontPageMenu.items);
    },
    calcIsMobile() {
      const isMobile = Number(window.innerWidth) < 768;
      this.$store.commit('SET_IS_MOBILE', isMobile);
    },
    pushDataLayer() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(this.dataLayerItem);
    },
  },
  metaInfo() {
    return {
      title: this.metaFromStore.title || '', // Titel aus dem Store
      meta: this.metaFromStore.meta, // Meta-Definitionen aus dem Store
    };
  },
};
</script>
